var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNewUser(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 9 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 0c.636 0 1.257.161 1.786.463.528.303.94.732 1.184 1.235.243.502.307 1.055.183 1.589a2.654 2.654 0 01-.88 1.408 3.413 3.413 0 01-1.646.752 3.721 3.721 0 01-1.857-.156 3.159 3.159 0 01-1.443-1.013 2.477 2.477 0 01-.541-1.528l.003-.12c.036-.707.39-1.376.988-1.866C2.875.274 3.672 0 4.5 0zm1.286 6.6c.852 0 1.67.29 2.273.805C8.66 7.921 9 8.621 9 9.35v.55c0 .292-.135.572-.377.778a1.403 1.403 0 01-.909.322H1.286c-.341 0-.668-.116-.91-.322A1.026 1.026 0 010 9.9v-.55c0-.73.339-1.429.941-1.945.603-.515 1.42-.805 2.273-.805h2.572z",
    fill: "#CDCDCD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewUser);
export default ForwardRef;